module.exports = __webpack_public_path__ + "static/media/IRON.31b46214.png";